import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons/index.js'

import '@/icons' // icon

Vue.use(ElementUI, {
  locale
})

Vue.config.productionTip = false


import ax from 'axios'
import VDistpicker from 'v-distpicker'

import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

const echarts = require('echarts');
Vue.prototype.$echarts = echarts

import Print from './utils/print'
Vue.use(Print)
// 
//  ax.defaults.baseURL = "http://192.168.1.164:8080/stage";
// ax.defaults.baseURL = "https://mall.yscats.com/admin/stage";
 ax.defaults.baseURL ="https://mall-test.yscats.com/admin/stage";
ax.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// ax.defaults.timeout=5000
//设置axios请求头加入token
ax.interceptors.request.use(config => {
    if (config.url !== '/login') {
      if (localStorage.getItem('token')) {
        //在请求头加入token，名字要和后端接收请求头的token名字一样
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        config.headers['token'] = localStorage.getItem('token')
      }
    }
    if(config.url.indexOf('/refund/pageRefundOrder')!==-1||config.url.indexOf('/refund/getRefundOrderDetail')!==-1||config.url.indexOf('/refund/refundMoney')!==-1||config.url.indexOf('/refund/rejectRefund')!==-1||config.url.indexOf('/refund/okRefundOrder')!==-1){
      
      config.url = ax.defaults.baseURL.replace('admin/stage','finance')+config.url;
     
    }else{
      config.url =  ax.defaults.baseURL+config.url;
     
    }
    console.log(config.url)
    return config;
  },
  error => {
    return Promise.reject(error);
  });

//响应回来token是否过期
// eslint-disable-next-line no-unused-vars
ax.interceptors.response.use(response => {
    return response.data;

  },
  error => {
    let errors = error.response.data;
    if (errors.code === 10002 || errors.code === 10001 || errors.code === 10007) {
      localStorage.removeItem("token")
      router.push("/", null, () => {});
    }
    return Promise.reject(errors);
  })



window.axios = ax;
Vue.component('v-distpicker', VDistpicker);
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js